<template>
  <div class="home-main">
    <div v-show="!isLoading">
      <Header :screenWidth="screenWidth"></Header>
      <Menu :screenWidth="screenWidth"></Menu>

      <!--    轮播图  pc端 -->
      <div v-if="screenWidth > 1080" class="block" :style="'height:' + bannerHeight">
        <el-carousel :height="bannerHeight">
          <el-carousel-item v-for="(item, index) in imageList" :key="index">
            <el-image :src="item.url" style="height: 100%;width: 100%"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 轮播图 手机端 -->
      <div v-else class="block" :style="'height:' + bannerHeight">
        <el-carousel ref="slideCarousel" :height="bannerHeight">
          <el-carousel-item v-for="(item, index) in phoneImageList" :key="index">
            <el-image :src="item.url" style="height: 100%;width: 100%"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <foot></foot>
    </div>


    <div class="oly-loading" v-show="isLoading">
      <img src="https://olt-img.oss-cn-beijing.aliyuncs.com/loader.gif"></img>
    </div>
  </div>

</template>

<script>
import Header from "@/components/Header.vue";
import Menu from "@/components/Menu.vue";
import Foot from "@/components/Foot.vue";

export default {
  name: 'HomeView',
  components: {
    Header,Menu,Foot
  },
  created() {
    setTimeout(() => {
      this.isLoading = false;
    },1000)
  },
  mounted() {
    window.scrollTo(0, 0);
    this.screenWidth =  window.innerWidth;
    this.setSize();
    window.onresize = () =>{
      this.screenWidth =  window.innerWidth;
      this.setSize();
    };

    this.slideBanner()
  },
  methods: {
    setSize(){
      // 通过屏幕宽度(图片宽度)计算高度
      if (this.screenWidth > 1080) {
        this.bannerHeight = (736 / 1920 * this.screenWidth) + 'px';
      } else {
        this.bannerHeight = (1426 / 1080 * this.screenWidth) + 'px';
      }
    },

    // 滑动切换
    slideBanner() {
      //选中的轮播图
      let box = document.querySelector('.el-carousel__container');
      let startPoint = 0;
      let stopPoint = 0;
      //重置坐标
      let resetPoint = function () {
        startPoint = 0;
        stopPoint = 0;
      }
      //手指按下
      box.addEventListener("touchstart", function (e) {
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function (e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      let that = this
      box.addEventListener("touchend", function (e) {
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.slideCarousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.slideCarousel.prev();
          return;
        }
      });
    },

  },
  data(){
    return {
      isLoading: false,
      screenWidth: 0,
      bannerHeight: '',
      imageList: [
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/index-banner1.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/index-banner2.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/index-banner3.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/index-banner4.png",
        }
      ],
      phoneImageList: [
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/phone-index-banner1.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/phone-index-banner2.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/phone-index-banner3.png",
        },
        {
          url: "https://olt-img.oss-cn-beijing.aliyuncs.com/home/phone-index-banner4.png",
        }
      ]
    };
  }
}
</script>
<style scoped>
  .home-main{
    height: 100vh;
    background: #E9E9E9;
  }
</style>
